export const LIST_RATE = [
  {
    avatar_url: `${process.env.PUBLIC_URL}/images/rate/star-rating.png`,
    user_name: 'Olivia Martinez',
    message:
      'iFridge has revolutionized how I manage my fridge! The AI recipe suggestions are brilliant—I’ve discovered so many creative meals from leftovers. The weekly menu planning feature is a lifesaver for my busy schedule. Highly recommend it!',
    start: 5,
  },
  {
    avatar_url: `${process.env.PUBLIC_URL}/images/rate/star-rating.png`,
    user_name: 'Akira Tanaka',
    message:
      'このアプリは私のキッチン管理を完全に変えてくれました！冷蔵庫の残り物を使ったAIレシピ提案は素晴らしいです。買い物リスト機能のおかげで、無駄がなくなり、計画的な料理が可能になりました。必須アプリです！',
    start: 5,
  },
  {
    avatar_url: `${process.env.PUBLIC_URL}/images/rate/star-rating.png`,
    user_name: 'Fatima El-Sayed',
    message:
      'iFridge is amazing! The daily reports help me keep track of what’s in my fridge, and the shopping list ensures I never forget anything. It’s like having a personal kitchen assistant. A must-have for every household!',
    start: 5,
  },
  {
    avatar_url: `${process.env.PUBLIC_URL}/images/rate/star-rating.png`,
    user_name: 'Pierre Dupont',
    message:
      'iFridge est absolument génial! Grâce à cette application, je cuisine mieux avec ce que j’ai déjà dans mon réfrigérateur. Les suggestions de recettes sont délicieuses et m’aident à explorer différentes cuisines. Bravo pour cette application!',
    start: 5,
  },
];

export const LIST_LANGUAGE = ['en', 'vi', 'ja', 'es', 'zh', 'hi', 'ar', 'fr', 'pt', 'ko'];
